__turbopack_context__.v({
  "card": "BlockContactForm-module-scss-module__KZeyFG__card",
  "chatbot": "BlockContactForm-module-scss-module__KZeyFG__chatbot",
  "chatbotHeading": "BlockContactForm-module-scss-module__KZeyFG__chatbotHeading",
  "content": "BlockContactForm-module-scss-module__KZeyFG__content",
  "detail": "BlockContactForm-module-scss-module__KZeyFG__detail",
  "disabled": "BlockContactForm-module-scss-module__KZeyFG__disabled",
  "exit": "BlockContactForm-module-scss-module__KZeyFG__exit",
  "fade": "BlockContactForm-module-scss-module__KZeyFG__fade",
  "fade-in": "BlockContactForm-module-scss-module__KZeyFG__fade-in",
  "fade-out": "BlockContactForm-module-scss-module__KZeyFG__fade-out",
  "grid": "BlockContactForm-module-scss-module__KZeyFG__grid",
  "hidden": "BlockContactForm-module-scss-module__KZeyFG__hidden",
  "icon": "BlockContactForm-module-scss-module__KZeyFG__icon",
  "isVisible": "BlockContactForm-module-scss-module__KZeyFG__isVisible",
  "label": "BlockContactForm-module-scss-module__KZeyFG__label",
  "lastBlock": "BlockContactForm-module-scss-module__KZeyFG__lastBlock",
  "newLabel": "BlockContactForm-module-scss-module__KZeyFG__newLabel",
  "resetButton": "BlockContactForm-module-scss-module__KZeyFG__resetButton",
  "root": "BlockContactForm-module-scss-module__KZeyFG__root",
});
